<!--
 * @Author: your name
 * @Date: 2022-04-28 16:11:13
 * @LastEditTime: 2022-04-29 10:58:51
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ant-design-vue-jeecg\src\views\modules\okr\modules\AllPlanReviseList copy.vue
-->
<template>
  <!-- table区域-begin -->
  <div class="table-container">
    <a-table
      ref="table"
      size="middle"
      bordered
      rowKey="id"
      class="j-table-force-nowrap"
      :scroll="{ x: true }"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio' }"
      :customRow="clickThenSelect"
      @change="handleTableChange"
    >
    </a-table>
    <a-drawer
      :visible="visible"
      title="打分详情"
      :closable="false"
      placement="right"
      :after-visible-change="afterVisibleChange"
      :width="900"
      @close="onClose"
    >
      <all-plan-list-with-sorce ref="listRevise" />
    </a-drawer>
  </div>
</template>


<script>
import Vue from 'vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import AllPlanListWithSorce from './AllPlanListWithSorce.vue'

export default Vue.extend({
  name: 'MarkSummaryReviseList',
  components: { AllPlanListWithSorce },
  mixins: [JeecgListMixin],
  data() {
    return {
      model: {},
      // 表头
      columns: [
        {
          title: '用户',
          align: 'center',
          dataIndex: 'realname',
        },
        {
          title: '价值观评价',
          align: 'center',
          dataIndex: 'worthEvaluate',
        },
        {
          title: '总得分',
          align: 'center',
          dataIndex: 'score',
        },
        {
          title: '评价总结',
          align: 'center',
          dataIndex: 'summary',
        },
      ],
      url: {
        list: `${window._CONFIG['doBaseUrl']}/doMistServer/okrSummary/getSummaryReviseWithSorcebyGroupId`,
      },
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '50'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      selectedMainId: '',
      selectedRowKeys: [],
      visible: false,
    }
  },
  methods: {
    handleQuery1(filters) {
      this.filters = filters
      this.loadData()
    },
    clickThenSelect(record) {
      return {
        on: {
          click: () => {
            this.onSelectChange(record.id.split(','), [record])
          },
        },
      }
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedMainId = selectedRowKeys[0]
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
      this.visible = true
      this.$nextTick(() => {
        if (this.selectionRows[0].okrGroupId) {
          this.$refs.listRevise.handleQuery({
            summaryId: this.selectionRows[0].okrGroupId,
            userIds: this.selectionRows[0].createBy,
          })
        }
      })
    },
    afterVisibleChange(val) {
      if (val) {
      } else {
        this.visible = val
      }
    },
    onClose() {
      this.visible = false
    },
  },
})
</script>

<style lang="less" scoped>
@import '~@assets/less/common.less';

.table-container /deep/td {
  white-space: pre-wrap;
}
</style>
